(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gift-sets-preview"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('change',event=>{
 if(!event.target.matches('[data-gift-colour]'))return;
 const card=event.target.closest('[data-gift-card]');
 const section=card.closest('.gift-preview');
 const records=JSON.parse(section.querySelector('[data-gift-images]').textContent);
 const part=event.target.dataset.giftPart;
 const chosen=records.find(item=>item.colour===event.target.value);
 if(!chosen)return;
 const image=card.querySelector('[data-gift-'+part+']');
 if(image&&chosen[part]){image.src=chosen[part];image.alt=chosen.colour+' '+(part==='holder'?'record holder':'turntable weight');}
 const summary=Array.from(card.querySelectorAll('[data-gift-part]')).map(select=>select.dataset.giftPart+': '+select.value).join(' · ');
 card.querySelector('.gift-preview__selection').textContent=summary+(card.querySelector('[data-gift-part="brush"]')?' — Brush photo shown in Orange.':'');
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
